import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessOverviewSummaryRoute: InvariantJiraRoute = {
	name: 'classic-business-overview-summary',
	path: '/jira/core/overviews/:overviewId/summary',
	exact: true,
};
